var _circle, _mask, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarHallow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2875,
    cy: 25.2875,
    r: 10.569,
    stroke: "#FF6E04",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_8_25159",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3452 31.0787C19.1562 29.8211 18.4204 28.203 18.2543 26.4802C18.0881 24.7575 18.5011 23.0286 19.4278 21.5669C20.3545 20.1052 21.7421 18.9942 23.3711 18.4096C25.0001 17.8251 26.7776 17.8003 28.4222 18.3392L27.6368 20.7359C26.5253 20.3716 25.324 20.3884 24.223 20.7834C23.122 21.1785 22.1842 21.9294 21.5578 22.9173C20.9315 23.9052 20.6524 25.0738 20.7647 26.2381C20.877 27.4024 21.3743 28.4961 22.1779 29.3461L20.3452 31.0787Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3452 31.0787C19.1562 29.8211 18.4204 28.203 18.2543 26.4802C18.0881 24.7575 18.5011 23.0286 19.4278 21.5669C20.3545 20.1052 21.7421 18.9942 23.3711 18.4096C25.0001 17.8251 26.7776 17.8003 28.4222 18.3392L27.6368 20.7359C26.5253 20.3716 25.324 20.3884 24.223 20.7834C23.122 21.1785 22.1842 21.9294 21.5578 22.9173C20.9315 23.9052 20.6524 25.0738 20.7647 26.2381C20.877 27.4024 21.3743 28.4961 22.1779 29.3461L20.3452 31.0787Z",
    stroke: "#FF6E04",
    strokeWidth: 6,
    strokeLinecap: "round",
    mask: "url(#path-2-inside-1_8_25159)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.5002,
    y1: 4.82166,
    x2: 23.5002,
    y2: 1.49982,
    stroke: "#FF6E04",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.5002,
    y1: 48.4999,
    x2: 23.5002,
    y2: 45.178,
    stroke: "#FF6E04",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 45.1783,
    y1: 23.4999,
    x2: 48.5002,
    y2: 23.4999,
    stroke: "#FF6E04",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.50018,
    y1: 23.4999,
    x2: 4.82202,
    y2: 23.4999,
    stroke: "#FF6E04",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 38.2075,
    y1: 9.67079,
    x2: 40.5564,
    y2: 7.3219,
    stroke: "#FF6E04",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7.32269,
    y1: 40.556,
    x2: 9.67159,
    y2: 38.2072,
    stroke: "#FF6E04",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 40.3288,
    y1: 38.2075,
    x2: 42.6777,
    y2: 40.5564,
    stroke: "#FF6E04",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 9.44401,
    y1: 7.32227,
    x2: 11.7929,
    y2: 9.67116,
    stroke: "#FF6E04",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarHallow);
export default __webpack_public_path__ + "static/media/solar_hallow.e4b179b76db7e75951720cb2de417ede.svg";
export { ForwardRef as ReactComponent };